import { SkeletonTheme } from "react-loading-skeleton";

export const BaseSkeletonTheme = ({ children }) => {
  return (
    <SkeletonTheme
      borderRadius="12px"
      baseColor="var(--card-default)"
      customHighlightBackground="linear-gradient(90deg, var(--card-default) 0%, var(--card-active) 46.67%, var(--card-default) 98.67%)"
    >
      {children}
    </SkeletonTheme>
  );
};
